import { BarChart } from '@mantine/charts';
import { Card, Text } from '@mantine/core';

const data = [
  { month: 'Jan', revenue: 1200 },
  { month: 'Feb', revenue: 1900 },
  { month: 'Mar', revenue: 1500 },
  { month: 'Apr', revenue: 2400 },
];

export const ChartLibrarySmokeTest = () => {
  return (
    <Card withBorder padding="md" mb="md">
      <Text size="sm" c="dimmed" mb="xs">
        Chart library smoke test (FNP-189) — replace with real charts in FNP-191.
      </Text>
      <BarChart
        h={200}
        data={data}
        dataKey="month"
        series={[{ name: 'revenue', color: 'blue.6' }]}
      />
    </Card>
  );
};
